import type { ChartFeatures } from "./PriceChart";
import { cn } from "@/lib/utils";

const TOGGLES: { key: keyof ChartFeatures; label: string }[] = [
  { key: "volume", label: "Volym" },
  { key: "ema", label: "EMA" },
  { key: "rsi", label: "RSI" },
  { key: "macd", label: "MACD" },
  { key: "signals", label: "Signaler" },
  { key: "costLines", label: "GAV-linjer" },
];

export function ChartControls({
  features,
  onToggle,
}: {
  features: ChartFeatures;
  onToggle: (key: keyof ChartFeatures) => void;
}) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {TOGGLES.map((t) => {
        const active = features[t.key];
        return (
          <button
            key={t.key}
            onClick={() => onToggle(t.key)}
            aria-pressed={active}
            className={cn(
              "rounded-md border px-2.5 py-1 text-xs font-medium transition-colors",
              active
                ? "border-primary/40 bg-primary/15 text-foreground"
                : "border-border bg-transparent text-muted-foreground hover:text-foreground",
            )}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
